<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="31.5">
        <g data-name="Group 196">
            <path
                d="M28.75 0h-26A2.752 2.752 0 0 0 0 2.75v26a2.751 2.751 0 0 0 2.75 2.75h22.895l5.855-5.855V2.75A2.752 2.752 0 0 0 28.75 0Zm-4.167 2.042a1.479 1.479 0 1 1 0 2.958 1.479 1.479 0 0 1 0-2.958Zm-4.417 0a1.48 1.48 0 1 1 0 2.959 1.48 1.48 0 0 1 0-2.959Zm-4.416 0a1.48 1.48 0 1 1 0 2.959 1.48 1.48 0 0 1 0-2.959Zm-4.416 0a1.48 1.48 0 1 1 0 2.959 1.48 1.48 0 0 1 0-2.959Zm-4.417 0a1.479 1.479 0 1 1 0 2.958 1.479 1.479 0 0 1 0-2.958ZM30 25.023l-.311.311h-2.355c-1.102 0-2 .9-2 2v2.355l-.311.311H2.75c-.689 0-1.25-.561-1.25-1.25v-22H30v18.273Z"
                :fill="color || '#333'"
                fill-rule="evenodd"
                data-name="Path 760"
            />
            <path
                d="M15.75 10.636c4.475 0 8.115 3.64 8.115 8.115h1.41c0-5.253-4.273-9.527-9.525-9.527-5.252 0-9.525 4.273-9.525 9.527h1.411c-.001-4.476 3.639-8.115 8.114-8.115Z"
                :fill="color || '#333'"
                fill-rule="evenodd"
                data-name="Path 761"
            />
            <path
                d="M15.75 11.871a6.888 6.888 0 0 0-6.88 6.88h1.411a5.474 5.474 0 0 1 5.469-5.469 5.474 5.474 0 0 1 5.469 5.469h1.411a6.888 6.888 0 0 0-6.88-6.88Z"
                :fill="color || '#333'"
                fill-rule="evenodd"
                data-name="Path 762"
            />
            <path
                d="M15.75 14.517a4.238 4.238 0 0 0-4.233 4.234h1.411a2.825 2.825 0 0 1 2.822-2.823 2.826 2.826 0 0 1 2.823 2.823h1.409a4.237 4.237 0 0 0-4.232-4.234Z"
                :fill="color || '#333'"
                fill-rule="evenodd"
                data-name="Path 763"
            />
            <path
                d="M16.529 18.751a.778.778 0 1 0-1.558 0 .77.77 0 0 0 .534.729l-2.948 8.797h6.386l-2.948-8.797a.77.77 0 0 0 .534-.729Z"
                :fill="color || '#333'"
                fill-rule="evenodd"
                data-name="Path 764"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Wifi",
    props: ["color"],
};
</script>
